import angular from 'angular';
import { FailedOrdersModule } from './failed-orders/failed-orders.module';
import { FrequentOrdersModule } from './frequent-orders/frequent-orders.module';
import { MyOrdersActionsMenuModule } from './my-orders-actions-menu/my-orders-actions-menu.module';
import { OrderDetailsModule } from './order-details/order-details.module';
import { OrderHistoryModule } from './order-history/order-history.module';
import { ReorderProductsModule } from './reorder-products/reorder-products.module';
import { OrderService } from './order.service';
import { OrderPageHolderComponent } from './order-page-holder/order-page-holder.component';
export var AccountOrdersModule = angular
    .module('eeComUiApp.orders', [
    FailedOrdersModule,
    FrequentOrdersModule,
    MyOrdersActionsMenuModule,
    OrderDetailsModule,
    OrderHistoryModule,
    ReorderProductsModule
])
    .component('orderPageHolder', OrderPageHolderComponent)
    .service('OrderService', OrderService)
    .name;
//# sourceMappingURL=orders.module.js.map